import { action } from 'satcheljs';
import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';

/**
 * Action to update the calendar processing options in store
 */

export let updateCalendarProcessingOptions = action(
    'updateCalendarProcessingOptions',
    (calendarProcessingOptions: CalendarProcessingOptions) => ({
        calendarProcessingOptions: calendarProcessingOptions,
    })
);
export default updateCalendarProcessingOptions;
